"use client";

import {
  AdapterNotDetectedWallet,
  AdapterWallet,
  isInstallRequired,
  shouldUseFallbackWallet,
  WalletItem,
} from "@aptos-labs/wallet-adapter-react";
import { Button } from "@decibeltrade/web-core/components";
import { useTranslations } from "next-intl";
import { css } from "styled-system/css";
import { flex } from "styled-system/patterns";

interface WalletRowProps {
  wallet: AdapterWallet | AdapterNotDetectedWallet;
  onConnect?: () => void;
}

export function WalletRow({ wallet, onConnect }: WalletRowProps) {
  const t = useTranslations("walletSelector");
  return (
    <WalletItem
      wallet={wallet}
      onConnect={onConnect}
      className={flex({
        align: "center",
        justify: "space-between",
        gap: "16",
        pl: "20",
        pr: "[6px]",
        py: "[6px]",
      })}
    >
      <div className={flex({ align: "center", gap: "16" })}>
        <WalletItem.Icon className={css({ h: "24", w: "24" })} />
        <span className={css({ textStyle: "body.md" })}>{formatWalletName(wallet.name)}</span>
      </div>
      {shouldUseFallbackWallet(wallet) ? (
        <WalletItem.ConnectButton asChild>
          <Button size="sm" variant="secondary">
            {t("connect")}
          </Button>
        </WalletItem.ConnectButton>
      ) : isInstallRequired(wallet) ? (
        <Button
          size="sm"
          variant="text"
          render={(children) => <WalletItem.InstallLink>{children}</WalletItem.InstallLink>}
        >
          {t("install")}
        </Button>
      ) : (
        <WalletItem.ConnectButton asChild>
          <Button size="sm" variant="secondary">
            {t("connect")}
          </Button>
        </WalletItem.ConnectButton>
      )}
    </WalletItem>
  );
}

export function AptosConnectWalletRow({ wallet, onConnect }: WalletRowProps) {
  return (
    <WalletItem wallet={wallet} onConnect={onConnect}>
      <WalletItem.ConnectButton asChild>
        <Button size="lg" variant="secondary" fullWidth>
          <div className={flex({ align: "center", gap: "16" })}>
            <WalletItem.Icon className={css({ h: "24", w: "24" })} />
            <WalletItem.Name />
          </div>
        </Button>
      </WalletItem.ConnectButton>
    </WalletItem>
  );
}

const formatWalletName = (name: string) => {
  return name.replace("(Ethereum)", "").replace("(Solana)", "").replace("(Sui)", "").trim();
};
